import { render, staticRenderFns } from "./ParentProfile.vue?vue&type=template&id=16071faa&scoped=true"
import script from "./ParentProfile.vue?vue&type=script&lang=js"
export * from "./ParentProfile.vue?vue&type=script&lang=js"
import style0 from "./ParentProfile.vue?vue&type=style&index=0&id=16071faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16071faa",
  null
  
)

export default component.exports